import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
const heroImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/pWgy84cwW8jtAeewHa4kgC/ChatGPT_Image_1_may_2026,_01_34_59.png',
  alt: 'Palomitas Gourmet - Curso Digital'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dyvKJRCiuNow4QcK92nt81/ChatGPT_Image_1_may_2026,_01_46_36.png',
  alt: 'Palomitas Gourmet - Curso Digital Candy Bar'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5BGwFqHujaHQwrAS4M9kKg/ChatGPT_Image_30_abr_2026,_17_45_21.png',
  alt: 'Palomitas Gourmet - Libro, tablet y celular'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iYJtF8GrG4B9gLDGhvPH48/ChatGPT_Image_1_may_2026,_01_46_51.png',
  alt: 'Candy Bar Gourmet - Curso Digital'
}];
export function Hero() {
  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % heroImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative overflow-hidden bg-palomitas-dark" data-id="element-125">
      {/* Colorful accent blobs over dark background */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-126">
        <div className="absolute top-[-15%] right-[-10%] w-[500px] h-[500px] bg-palomitas-coral/15 rounded-full blur-3xl" data-id="element-127"></div>
        <div className="absolute bottom-[-15%] left-[-10%] w-[500px] h-[500px] bg-palomitas-gold/15 rounded-full blur-3xl" data-id="element-128"></div>
        <div className="absolute top-[40%] left-[30%] w-72 h-72 bg-palomitas-pink/10 rounded-full blur-3xl" data-id="element-129"></div>
      </div>

      {/* Text Content */}
      <div className="container px-4 pt-16 pb-10 mx-auto text-center max-w-4xl relative z-10" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-131">
          <span className="inline-block bg-white/20 backdrop-blur-sm text-white px-5 py-2 rounded-full font-bold text-sm uppercase tracking-wide mb-6 border border-white/30" data-id="element-132">
            🍿 El negocio más dulce desde tu casa
          </span>

          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-lg" data-id="element-133">
            Convertí <span className="text-yellow-200" data-id="element-134">$3.500</span> en{' '}
            <span className="text-yellow-200" data-id="element-135">$35.000</span> por día desde tu
            casa 🍿💰
          </h1>

          <p className="text-xl md:text-2xl text-white/90 mb-10 font-medium max-w-3xl mx-auto drop-shadow" data-id="element-136">
            Aprendé a vender Palomitas Gourmet con un sistema simple, incluso si
            empezás desde cero.
          </p>

          <div className="flex flex-col items-center gap-4 mb-10" data-id="element-137">
            <Button href="#oferta" className="w-full sm:w-auto text-xl px-10 py-5 !bg-palomitas-gold !text-white hover:!bg-palomitas-goldHover shadow-2xl" data-id="element-138">
              👉 Empezar ahora
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Image Carousel */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.3
    }} className="w-full max-w-5xl mx-auto px-4 pb-16 relative z-10" data-id="element-139">
        <div className="relative w-full overflow-hidden rounded-2xl shadow-2xl border-4 border-white/30" data-id="element-140">
          {heroImages.map((image, index) => <motion.img key={index} src={image.src} alt={image.alt} className={`w-full h-auto block ${index === 0 ? 'relative' : 'absolute inset-0'}`} animate={{
          opacity: index === currentImage ? 1 : 0
        }} transition={{
          duration: 1,
          ease: 'easeInOut'
        }} data-id="element-141" />)}
        </div>
        {/* Dots indicator */}
        <div className="flex justify-center gap-2 mt-4" data-id="element-142">
          {heroImages.map((_, index) => <span key={index} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${index === currentImage ? 'bg-palomitas-gold scale-125' : 'bg-white/40'}`} data-id="element-143" />)}
        </div>
      </motion.div>
    </section>;
}